import { Text } from 'bold-ui'
import { useMedicoesCardQuery } from 'graphql/hooks.generated'
import React from 'react'
import { useHistory, useRouteMatch } from 'react-router'

import { AccordionCardSection } from '../components/AccordionCardSection'
import { ContentCardSection } from '../components/ContentCardSection'
import { SubtitleCard } from '../components/SubtitleCard'
import { MedicoesListCard } from './components/MedicoesListCard'
import convertInputToModelAndFormat from './convertInputToModelAndFormat'

export interface MedicoesCardProps {
  prontuarioId: ID
  dataAtendimento: Instant
}

export function MedicoesCard(props: MedicoesCardProps) {
  const { dataAtendimento, prontuarioId } = props
  const history = useHistory()
  const match = useRouteMatch()

  const { data, loading } = useMedicoesCardQuery({
    variables: {
      filtro: {
        prontuarioId: prontuarioId,
        data: dataAtendimento,
      },
    },
  })

  const todasMedicoes = convertInputToModelAndFormat(data?.ultimasMedicoesDoDia, data?.ultimasMedicoesDiasAnteriores)
  const medicoesHoje = todasMedicoes.getMedicoesHoje()
  const medicoesAnterioresExpandido = todasMedicoes.getMedicoesAnterioresExpandido()
  const medicoesAnterioresAccordion = todasMedicoes.getMedicoesAnterioresAccordion()

  const handleClick = () => history.push(`${match.url}/historicoMedicoes`)

  return (
    <>
      <ContentCardSection
        tooltip='Ver histórico de medições'
        isLoading={loading}
        messageLoading='Carregando dados das medições'
        onClick={handleClick}
      >
        <SubtitleCard title='De hoje' />
        <MedicoesListCard medicoes={medicoesHoje} />
        {medicoesHoje.length === 0 && <Text component='p'>Nenhuma medição registrada hoje.</Text>}

        <SubtitleCard title='Anteriores' />
        <MedicoesListCard medicoes={medicoesAnterioresExpandido} isListMedicaoAnterior />
        {medicoesAnterioresExpandido.length === 0 && (
          <Text component='p'>Nenhuma medição realizada em dias anteriores.</Text>
        )}
      </ContentCardSection>

      {medicoesAnterioresAccordion.length > 0 && (
        <AccordionCardSection
          title={{
            closed: `Mostrar + ${medicoesAnterioresAccordion.length} medições`,
            open: `Esconder medições`,
          }}
        >
          <MedicoesListCard medicoes={medicoesAnterioresAccordion} isListMedicaoAnterior />
          {medicoesAnterioresAccordion.length === 0 && (
            <Text component='p'>Nenhuma medição realizada em dias anteriores.</Text>
          )}
        </AccordionCardSection>
      )}
    </>
  )
}
